import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input } from '@angular/core';
import { PrometRobeZaKomitentaPoArtiklima } from './promet-robe-za-komitenta-po-artiklima';
import { ModalContainerService, BaseCommonComponent, UserService, BaseDataService, ModelDataService, ModalService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl } from '@angular/forms';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-promet-robe-za-komitenta-po-artiklima-ukupno',
    templateUrl: './promet-robe-za-komitenta-po-artiklima-ukupno.component.html'
})
export class PrometRobeZaKomitentaPoArtiklimaUkupnoComponent
extends BaseCommonComponent
implements OnInit {

    @Input() Parameters;
    items;

    baseFormGroup: FormGroup = new FormGroup({
        T01VrednostUlazaPoNabavnojCeni: new FormControl()
        , T02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni: new FormControl()
        , T03VrednostIzlazaArtikalaPoProdajnojCeni: new FormControl()
        , T04UkupnoPdvIzlazRobe: new FormControl()
        , T05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv: new FormControl()
        , T06RealizacijaDoUlozenogNovca: new FormControl()
        , T07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda: new FormControl()
      })
      

    constructor(
        protected activeModal: NgbActiveModal,
        protected activatedRoute: ActivatedRoute,
        protected userService: UserService,
        protected baseDataService: BaseDataService,
        protected translateService: TranslateService,
        protected modelDataService: ModelDataService,
        protected modalService: ModalService,
        // protected notificationService: NotificationsService
        protected toastrService: NotificationService
        ) {
        super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.baseFormGroup.patchValue({ T01VrednostUlazaPoNabavnojCeni: this.Parameters[0].Value });
        this.baseFormGroup.patchValue({ T02VrednostIzlazaArtikalaPoProsecnojNabavnojCeni: this.Parameters[1].Value });
        this.baseFormGroup.patchValue({ T03VrednostIzlazaArtikalaPoProdajnojCeni: this.Parameters[2].Value });
        this.baseFormGroup.patchValue({ T04UkupnoPdvIzlazRobe: this.Parameters[3].Value });
        this.baseFormGroup.patchValue({ T05VrednostIzlazaArtikalaPoProdajnojCeniBezPdv: this.Parameters[4].Value });
        this.baseFormGroup.patchValue({ T06RealizacijaDoUlozenogNovca: this.Parameters[5].Value });
        this.baseFormGroup.patchValue({ T07UkupnoOstvarenaRazlikaUCeniNaKrajuPerioda: this.Parameters[6].Value });

    }

    Close() {
        this.activeModal.dismiss();
    }

}
